// Values that couldn't be written to sessionStorage (e.g. quota exceeded or
// storage blocked) are kept here, so reads still see them even when
// sessionStorage itself is readable.
const inMemoryStorage = new Map<string, string>();

export function getItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key) ?? inMemoryStorage.get(key) ?? null;
  } catch {
    return inMemoryStorage.get(key) ?? null;
  }
}

export function setItem(key: string, value: string) {
  try {
    sessionStorage.setItem(key, value);
    inMemoryStorage.delete(key);
  } catch {
    inMemoryStorage.set(key, value);
  }
}

export function removeItem(key: string) {
  inMemoryStorage.delete(key);
  try {
    sessionStorage.removeItem(key);
  } catch {
    // Nothing more to remove; the in-memory copy is already gone.
  }
}
